import catalogue from "javascriptstuff-db";

// These should be all the lists that are NOT marked as drafts.
// It is a bit tricky to do this in an automatic (not hard-coded) way.
// I also use this list to set the order in which things show up in the
// home page topic list.
const keys = [
  `react-components`,
  `react-example-apps`,
  `react-starter-projects`,
  `style-libraries`,
  `static-site-generators`,
  `devtools`,
  `state-managers`,
  `linters`,
  `view-libraries`,
  `react-tutorials`
];

/**
 * Filtered to only include the lists that I want to appear in search and on
 * the home page.
 */
export default keys
  .map(key => catalogue.find(item => item.key === key))
  .map(item => Object.assign({}, item, { path: `/${item.key}/` }));



// WEBPACK FOOTER //
// ./src/catalogue/list-catalogue.js